import type { ExportJobDetail, ExportJobFile } from "@/types/api";

export function sortedExportFiles(job: ExportJobDetail): ExportJobFile[] {
  const files = job.files ?? [];
  return [...files].sort((a, b) => (a.volume_index ?? 0) - (b.volume_index ?? 0));
}
